import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Button, Card, Typography, Box } from "@curves/ui-base";
import { MembershipCreateHistoryTable } from '@icoach/documents/table';
import useDocMembershipApi from '@apis/useDocMembershipApi';

const MembershipCreateHistory = (props) => {
    const { onBlankContractClick } = props;
    const history = useHistory();
    const { peopleType: peopleTypeProps, referenceID: referenceIDProps } = useParams();
    const { getDocMembershipHistoryApi } = useDocMembershipApi();
    const [sourceData, setSourceData] = useState([]);

    // 按鈕 建立新表單
    const handleCreateButtonClick = () => {
        onBlankContractClick && onBlankContractClick();
    };

    // 重新抓取資料
    const handleRefresh = useCallback(
        () => {
            doDocMembershipHistoryApi(peopleTypeProps, referenceIDProps);
        },
        // eslint-disable-next-line
        [peopleTypeProps, referenceIDProps]
    );

    // 讀取該對象的歷史紀錄
    const doDocMembershipHistoryApi = async (type, id) => {
        let resp = await getDocMembershipHistoryApi({ type, id });
        if (resp) {
            setSourceData(resp);
        }
    };

    useEffect(
        () => {
            doDocMembershipHistoryApi(peopleTypeProps, referenceIDProps);
        },
        // eslint-disable-next-line
        []
    );

    useEffect(
        () => {
            // 重刷頁面才會用 REPLACE
            if (history.action === 'REPLACE') {
                doDocMembershipHistoryApi(peopleTypeProps, referenceIDProps);
            }
        },
        // eslint-disable-next-line
        [history.location]
    );

    return (
        <Card>
            <Card.CardContent className="document-history-list">
                <Box component="header" className={'page-header'}>
                    <Typography className={'page-header-title'} variant={'h3'}>
                        歷史紀錄
                    </Typography>
                    <Box className="btn-group">
                        <Button name="create" variant="outlined" color="secondary" onClick={handleCreateButtonClick}>
                            建立新表單
                        </Button>
                    </Box>
                </Box>
                <MembershipCreateHistoryTable className={'theme-gray'} rowsData={sourceData} onRefresh={handleRefresh} />
            </Card.CardContent>
        </Card>
    );
};

export default MembershipCreateHistory;
